module.exports = __webpack_public_path__ + "static/work_BB_Mega_baloons_full-2c072bce3a6148157604eb8f3404675e.mp4";